import results from '../results/companyresult';

export default (index) => {
  return results[index];
}
